import { LoadingStatus, StatusWidgetContainer } from '@apps-common/apps/portal/pages/units/pages/manage/components'
import { ImageComponent } from '@apps-common/components/common'
import { IStatusModel } from '@apps-common/utils/device-status'
import classNames from 'classnames'

interface IProps {
  loading: boolean
  data: IStatusModel | undefined
  classes?: string
}

export const ProductStatus = ({ loading, data, classes }: IProps) => {
  if (loading) {
    return <LoadingStatus />
  }

  return (
    <StatusWidgetContainer>
      {!loading && (
        <div
          className={classNames(
            classes,
            'text-text-muted text-center px-[6px] py-[4px] rounded-[12px] flex flex-col items-center justify-between gap-[2px] h-[50px] sm:h-[60px] w-[58px] overflow-hidden'
          )}
        >
          <div className='rounded-md p-[5px]'>
            <ImageComponent
              src={data?.imageUrl || ''}
              alt={data?.name || 'Product image'}
              containerClasses='sm:h-[24px] sm:w-[24px] flex items-center justify-center'
              imageClasses='max-h-[18px] max-w-[18px] sm:max-h-[24px] sm:max-w-[24px] ml-auto mr-auto'
              errorIconClasses='text-[20px] ml-auto mr-auto'
            />
          </div>
          <p className='uppercase jost-medium text-[9px] sm:text-[9px] sm:pb-[3px] line-clamp-1'>{data?.name}</p>
        </div>
      )}
    </StatusWidgetContainer>
  )
}
